export default __webpack_public_path__ + "static/media/screen-mockups.7b6cb4d9.svg";